export default __webpack_public_path__ + "static/media/github.bb30b65a.svg";